import React, { useEffect, useRef, useState } from "react";
import { Form, Modal, Table } from "react-bootstrap";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import obj from "../utils/helpers";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
const MatchOdds = ({ onClose, show, detail }) => {
  const [team, setTeam] = useState(detail?.runners[0]?.SelectionId);
  const divRef = useRef(null);
  const navigate = useNavigate();
  const [setting, setSetting] = useState({
    dots: false,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    initialSlide: 40,
  });
  const [result, setResult] = useState([]);
  const [back, setBack] = useState([]);
  const [lay, setLay] = useState([]);
  const getData = async () => {
    const { status, data } = await apiGet(apiPath.matchOddsRisk, {
      marketId: detail?.marketId,
    });
    if (status === 200) {
      if (data.success) {
        if (data?.results?.data?.length > 0) {
          let result = data?.results?.data[0]?.dataLog;
          let updated = result
            ?.map((res) => {
              return res?.runners?.map((item) => {
                return {
                  ...item,
                  time: res?.timestamp,
                  formated: obj.timeFormat(res?.timestamp),
                };
              });
            })
            .flat();
          // let newUpdated = updated?.map((res) => {
          //   return {
          //     ...res,
          //     backOdds: [res?.backOdds[0]],
          //     layOdds: [res?.layOdds[0]],
          //   };
          // });
          setResult(updated);
          let currentSelection = updated?.filter((res) => {
            return res?.selectionId == team;
          });
          let lay = currentSelection
            ?.map((item) => {
              return item?.layOdds?.map((obj) => {
                return { ...obj, time: item?.time, formated: item?.formated };
              });
            })
            .flat();

          let back = currentSelection
            ?.map((item) => {
              return item?.backOdds?.map((obj) => {
                return { ...obj, time: item?.time, formated: item?.formated };
              });
            })
            .flat()
            .sort((a, b) => {
              return new Date(b.time) - new Date(a.time);
            });
          setSetting((prev) => {
            return { ...prev, initialSlide: lay?.length - 3 };
          });
          setLay(lay);
          setBack(back);
        }
      }
    } else {
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handel = (id) => {
    setTeam(id);
    let currentSelection = result?.filter((res) => {
      return res?.selectionId == id;
    });
    let lay = currentSelection
      ?.map((item) => {
        return item?.layOdds?.map((obj) => {
          return { ...obj, time: item?.time, formated: item?.formated };
        });
      })
      .flat();

    let back = currentSelection
      ?.map((item) => {
        return item?.backOdds?.map((obj) => {
          return { ...obj, time: item?.time, formated: item?.formated };
        });
      })
      .flat()
      .sort((a, b) => {
        return new Date(b.time) - new Date(a.time);
      });
    setSetting((prev) => {
      return { ...prev, initialSlide: lay?.length - 3 };
    });
    setLay(lay);
    setBack(back);
  };
  let sliderRef = useRef(null);
  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };
  return (
    <Modal show={show} onHide={onClose}>
      <div className="market-depth-modal slide-up">
        <div className="market-title">
          <h5>Market Depth</h5>
        </div>

        <div className="market-depth-body">
          <div style={{ fontSize: "14px" }} className="match-point p-2 pb-0">
            <span className="master-pass">{detail?.eventName}</span>
            <span
              style={{ marginLeft: "4px", fontWeight: "700" }}
              className="master-pass"
            >
              - Match Odds
            </span>
          </div>

          <div className="select-container p-2">
            <Form.Select value={team} onChange={(e) => handel(e.target.value)}>
              {detail?.runners?.map((res) => {
                return (
                  <option value={res?.SelectionId} className={res?.RunnerName}>
                    {res?.RunnerName}
                  </option>
                );
              })}
            </Form.Select>
          </div>

          <Table className="border">
            <tbody>
              <tr>
                <td className="text-center">
                  Total matched
                  <strong class="d-block">{detail?.totalMatched}</strong>
                </td>
                <td className="text-center">
                  Selection Volume
                  <strong class="d-block">{detail?.totalMatched}</strong>
                </td>
                <td className="text-center">
                  Last price
                  <strong class="d-block">{lay[lay?.length - 1]?.price}</strong>
                </td>
              </tr>
            </tbody>
          </Table>

          <div className="balance-label position-relative exchange-label">
            Price, Exchange Available and Traded
          </div>

          <div className="d-flex justify-content-between mt-2 px-3 mb-2">
            <span
              onClick={previous}
              style={{ padding: "2px 4px", cursor: "pointer" }}
              className="bet-name d-flex align-items-center lay rounded fw-normal"
            >
              <FaAngleLeft size={14} className="text-success" />
              to Lay
            </span>
            <span
              onClick={next}
              style={{ padding: "2px 4px", cursor: "pointer" }}
              className="bet-name d-flex align-items-center  back rounded fw-normal"
            >
              to Back
              <FaAngleRight size={14} vclassName="text-danger" />
            </span>
          </div>

          {lay?.length > 0 && (
            <div className="to-back-to-lay slider-container">
              {/* <Table ref={divRef} responsive className="">
              <thead>
                <tr>
                  {" "}
                  {lay?.map((res) => {
                    return (
                      <th className="fw-normal text-center bet-name lay rounded-0">
                        <strong className="d-block">{res?.rt}</strong>
                        {res?.bv}
                      </th>
                    );
                  })}
                  {back?.map((res) => {
                    return (
                      <th className="fw-normal text-center bet-name back rounded-0">
                        <strong className="d-block">{res?.rt}</strong>
                        {res?.bv}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {lay?.map((res) => {
                    return <td>{res?.time}</td>;
                  })}
                  {back?.map((res) => {
                    return <td>{res?.time}</td>;
                  })}
                </tr>
              </tbody>
            </Table> */}
              <Slider
                className="mb-1"
                ref={(slider) => {
                  sliderRef = slider;
                }}
                {...setting}
              >
                {lay?.map((res) => {
                  return (
                    <div style={{ border: "1px solid grey" }}>
                      <div className="fw-normal text-center bet-name lay rounded-0 p-1">
                        <strong className="d-block">{res?.price}</strong>
                        {res?.size}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "4px",
                          background: "white",
                        }}
                      >
                        {res?.formated}
                      </div>
                    </div>
                  );
                })}

                {back?.map((res) => {
                  return (
                    <div style={{ border: "1px solid grey" }}>
                      <div className="fw-normal text-center bet-name back rounded-0 p-1">
                        <strong className="d-block">{res?.price}</strong>
                        {res?.size}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "4px",
                          background: "white",
                        }}
                      >
                        {res?.formated}
                      </div>
                    </div>
                  );
                })}
              </Slider>
              <div
                onClick={() =>
                  navigate(
                    `/matchoddslist/${detail?.eventId}/${detail?.marketId}`
                  )
                }
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  marginBottom: "4px",
                  textDecoration: "underline",
                  color: "black",
                  paddingRight: "4px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                .....view more
              </div>
            </div>
          )}
        </div>
      </div>{" "}
    </Modal>
  );
};

export default MatchOdds;
